import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, css, fonts, glyphs } from "../../../Styles";
import { NumberDisplayList, UNIT, EsfStationEnhanced } from "../..";
import { ButtonTypes, ListData_ValueTypes, TableStyles_Types } from "../../../Definitions";
import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { ReactiveTable } from "../../Tables/reactiveTableRenderer";
import { EsfLocation, StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { NewButtonList } from "../../BaseComponents/newButton";
import MotorSpecs from "../../motorSpecs";
import { useAppSelector } from "../../../Store";
import { TerminalInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";
import { useColumnConstructor } from "../../Tables/_Tables/useColumnConstructor";
import { FeedComponentInfo } from "../../../Services";

// TODO: testdata

// #region | Testdata
const terminalsForPen = [
  {
    fk_locations: 1,
    fk_devices: undefined,
    fk_terminal_types: undefined,
    port: undefined,
    fk_components: undefined,
    terminal_config_id: undefined,
    parent: undefined,
    next: undefined,
    sensor_p: undefined,
  } as TerminalInfo,
  {
    fk_locations: 1,
    fk_devices: undefined,
    fk_terminal_types: undefined,
    port: undefined,
    fk_components: undefined,
    terminal_config_id: undefined,
    parent: undefined,
    next: undefined,
    sensor_p: undefined,
  } as TerminalInfo,
  {
    fk_locations: 1,
    fk_devices: undefined,
    fk_terminal_types: undefined,
    port: undefined,
    fk_components: undefined,
    terminal_config_id: undefined,
    parent: undefined,
    next: undefined,
    sensor_p: undefined,
  } as TerminalInfo
]

const tableDatas = [{
  id: 1,
  feedSensor: "Paused",
  feedMotor: "Paused",
  components: [{
    id: 1,
    name: "Foder 1",
    readyMixture: true,
    priority: 1,
    ds: 0,
    energy: 0,
    protein: 0,
    deleted: false,
  } as FeedComponentInfo,]
},
{
  id: 2,
  feedSensor: "Paused",
  feedMotor: "Paused",
  components: [{
    id: 1,
    name: "Foder 1",
    readyMixture: true,
    priority: 1,
    ds: 0,
    energy: 0,
    protein: 0,
    deleted: false,
  } as FeedComponentInfo,]
  },
  {
    id: 3,
    feedSensor: "Paused",
    feedMotor: "Paused",
    components: [{
      id: 1,
      name: "Foder 1",
      readyMixture: true,
      priority: 1,
      ds: 0,
      energy: 0,
      protein: 0,
      deleted: false,
    } as FeedComponentInfo,]
  }]
  // #endregion

interface stationModal_Props {
  activeStation?: StationInfo;
}

export default function EsfStationModal({ activeStation }: stationModal_Props) {
  const { t } = useTranslation();
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const [currentContent, setCurrentContent] = useState<"STATION" | "LAST10DAYS" | "LOG">("STATION");

  const activeContent = (index: number) => (currentContent === "STATION" && index === 0) || (currentContent === "LAST10DAYS" && index === 1) || (currentContent === "LOG" && index === 2)

  // #region | Content Router
  const content_Router = () => {
    switch (currentContent) {
      case "LAST10DAYS":
        return (
          <>Number of feedings and amount of feed last 10 days</>
        )
      case "LOG":
        return (
          <>Last 10 events/eartags</>
        )
      case "STATION":
      default:
        return ( <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}> 
          <div style={{ display: "grid", gridTemplateColumns: "50px 1fr 1fr 1fr", gridTemplateRows: "1fr" }}>
            <p style={{ gridArea: "1/1/2/2", ...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{"No."}</p>
            <p style={{ gridArea: "1/2/2/3", ...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedMotor", {defaultValue: "feed motor"})}`}</p>
            <p style={{ gridArea: "1/3/2/4", ...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedSensor", {defaultValue: "feed sensor"})}`}</p>
            <p style={{ gridArea: "1/4/2/5", ...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedComponents", {defaultValue: "feed components"})}`}</p>
          </div>
          <div style={{ border: "2px solid " + colors.greyTertiary, borderRadius: "12px", width: "100%" }}>{
            <ReactiveTable
              minRows={5}
              table={table}
              tableType={TableStyles_Types.noHeaderTable}
              emptyText={t("feedCurvePages.feedCurve.noComponents", { defaultValue: "No components found" })}
              renderFooter={false}
            />
          }</div>
          <div style={{marginTop: "-2px"}}><EsfStationEnhanced currentlyAnimal={1000} previouslyAnimal={2000} onClick={() => console.log("gok")} components={true} /></div>
        </div> )
    }
  }
  // #endregion

  // NumberDisplayList: Currently in this station TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        height="64px"
        gridRows="1fr"
        units={[
          <UNIT content={"Kg"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>,
          <UNIT content={"Times"} color={colors.greyPrimary}/>
        ]}
        values={[ 0, 0 ]}
        headers={["fed today", "uses today"]}
      />
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // #region | Components Table
  const tableData = useMemo(() => {
    return tableDatas && tableDatas.length > 0
      ? tableDatas.map((td) => {
          return { 
            id: td.id, 
            feedComponent: td.components.map((component) => component.name).join(", "),
            feedMotor: td.feedMotor,
            feedSensor: td.feedSensor,
          };
        })
      : [];
  }, []);
  
  const accessorData = useMemo(() => ([
    { headerValue: "", accessor: "id", type: ListData_ValueTypes.String, width: "50px" },
    {headerValue: "", accessor: "feedSensor", type: ListData_ValueTypes.String},
    {headerValue: "", accessor: "feedMotor", type: ListData_ValueTypes.String},
    {headerValue: "", accessor: "feedComponent", type: ListData_ValueTypes.String}
  ]),[])
  
  const columns = useColumnConstructor({accessorData, tableStyle: TableStyles_Types.noHeaderTable, canEdit: false });

  const table = useReactTable({
    columns,
    data: tableData,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      columnPinning: {
        left: ["feedComponentNumber"]
      }
    },
  })
  // #endregion

  return (<>
    <div style={{ ...css.modalTop, height: "200px", alignItems: "flex-start" }}>
      <MotorSpecs terminals={terminalsForPen} farm={farm}/>
      {FeedCorrections}
    </div>
    <div style={{ ...css.seperatorLine }} />
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", gap: "20px" }}>
    <div style={{display: "flex", alignItems: "center", justifyContent: "center", padding: "0px 10px", borderTop: "1px solid "+colors.greyTertiary, borderBottom: "1px solid "+colors.greyTertiary, height: "40px", marginTop: "5px"}}>
      <NewButtonList
        contents={[
          t("esfWalkThroughPages.sections.station", {defaultValue: "station"}),
          t("esfWalkThroughPages.sections.stationLastDays", {defaultValue: "last 10 days"}),
          t("esfWalkThroughPages.sections.stationLog", {defaultValue: "log"}),
        ]}
        onClick={(i) => {
          if (i === 0) { setCurrentContent("STATION") }
          if (i === 1) { setCurrentContent("LAST10DAYS") }
          if (i === 2) { setCurrentContent("LOG")}
        }}
          buttonType={ButtonTypes.textButton}
          listOverrides={{
            listGap: "5px"
          }}
        overrides={(index) => ({
          baseStyles: {
            backgroundColor: activeContent(index) ? colors.greyDarkPrimary : colors.transparent,
            padding: "8px 10px",
            borderRadius: "10px",
          },
          hoverStyles: {
            opacity:activeContent(index) ? 1 : 0.5,
          },
          contentStyles: {
            color: activeContent(index) ? colors.greyLightTertiary : colors.greyDarkPrimary,
          }
        })}
        />
        </div>
      {content_Router()}
    </div>
  </>)
}